const HubSpotConnect = () => import('@/views/account/integrations/hubspot/hubspot-connect-view.vue');
const HubSpotManage = () => import('@/views/account/integrations/hubspot/hubspot-manage-view');

import store from '@/stores/index';

import HubSpotMappingRoutes from '@/routes/integrations/hubspot/mapping';
import HubSpotImportRoutes from '@/routes/integrations/hubspot/import';

export default [
    {
        path: '/Integrations/HubSpot/Manage',
        name: 'HubSpotManage',
        component: HubSpotManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage HubSpot Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage',
        name: 'ClientHubSpotManage',
        component: HubSpotManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage HubSpot Integration'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Connection',
        name: 'HubSpotConnect',
        component: HubSpotConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage HubSpot Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Connection',
        name: 'ClientHubSpotConnect',
        component: HubSpotConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage HubSpot Integration'
        }
    },
    ...HubSpotMappingRoutes,
    ...HubSpotImportRoutes
]